import React, { useState, useRef } from 'react';
import { FiFileText } from "react-icons/fi";
import { LuActivity, LuUser } from "react-icons/lu";
import './Scandinavian.css'
import handleSubmit from './ScoreUpload'
import { useAlert } from 'react-alert';
const Glasgow = ({ data }) => {
    const alert = useAlert()
    const [scores, setScores] = useState({
        eyeOpening: null,
        motorResponse: null,
        verbalResponse: null
    });
    const [info, setInfo] = useState({
        therapy_consultation: data?.therapy_id || '',
        id: data?.id || '',
        name: data?.name || '',
        age: data?.age || '',
        gender: data?.gender || '',
        mob: data?.mob || '',
        diagnosis: '',
        therapy_type: 'general'
    });
    const [loading, setLoading] = useState(false)
    const formRef = useRef()
    const assessmentData = [
        {
            category: 'eyeOpening',
            label: 'EYE OPENING',
            options: [
                { text: 'None', score: 1, description: 'Even to supra-orbital pressure' },
                { text: 'To pain', score: 2, description: 'Pain from sternum/limb/supra-orbital pressure' },
                { text: 'To speech', score: 3, description: 'Non-specific response, not necessarily to command' },
                { text: 'Spontaneous', score: 4, description: 'Eyes open, not necessarily aware' }
            ]
        },
        {
            category: 'motorResponse',
            label: 'MOTOR RESPONSE',
            options: [
                { text: 'None', score: 1, description: 'To any pain; limbs remain flaccid' },
                { text: 'Extension', score: 2, description: 'Shoulder adducted and shoulder and forearm internally rotated' },
                { text: 'Flexor response', score: 3, description: 'Withdrawal response or assumption of hemiplegic posture' },
                { text: 'Withdrawal', score: 4, description: 'Arm withdraws to pain, shoulder abducts' },
                { text: 'Localizes pain', score: 5, description: 'Arm attempts to remove supra-orbital/chest pressure' },
                { text: 'Obeys commands', score: 6, description: 'Follows simple commands' }
            ]
        },
        {
            category: 'verbalResponse',
            label: 'VERBAL RESPONSE',
            options: [
                { text: 'None', score: 1, description: 'No verbalization of any type' },
                { text: 'Incomprehensible', score: 2, description: 'Moans/groans, no speech' },
                { text: 'Inappropriate', score: 3, description: 'Intelligible, no sustained sentences' },
                { text: 'Confused', score: 4, description: 'Converses but confused, disoriented' },
                { text: 'Oriented', score: 5, description: 'Converses and oriented' }
            ]
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleScoreChange = (category, score) => {
        setScores(prev => ({
            ...prev,
            [category]: score
        }));
    };

    const calculateTotalScore = () => {
        return Object.values(scores).reduce((total, score) => {
            return total + (score !== null ? score : 0);
        }, 0);
    };

    const totalScore = calculateTotalScore();

    const handleCancel = () => {
        setScores({
            eyeOpening: null,
            motorResponse: null,
            verbalResponse: null
        });
    }
    const handleFormSubmit = async () => {
        setLoading(true)
        const result = await handleSubmit(info, formRef, 'gg_scale', alert, totalScore);

        if (result && result.success) {
            handleCancel()
        }
        if (result) {
            setLoading(false)
        }
    };

    return (
        <>
            <div className="general-form-content" ref={formRef}>
                <div className="section-header">
                    <h2>GLASGOW COMA SCALE ASSESSMENT FORM</h2>
                </div>
                <div className="assessment-table">
                    <table className="scale-table">
                        <thead>
                            <tr>
                                <th>Activity</th>
                                <th>Description</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assessmentData?.map((item, index) => (
                                <tr key={index} className="assessment-row">
                                    <td className="catgory-cell">
                                        <strong>{item.label}</strong>
                                    </td>
                                    <td className="description-cell">
                                        <div className="options-container">
                                            {item.options.map((option, optIndex) => (
                                                <label key={optIndex} className="option-label">
                                                    <input
                                                        type="radio"
                                                        name={item.category}
                                                        value={option.score}
                                                        checked={scores[item.category] === option.score}
                                                        onChange={() => handleScoreChange(item.category, option.score)}
                                                    />
                                                    <span className="option-text">
                                                        <strong>{option.text}</strong> - {option.description}
                                                    </span>
                                                    <span className="option-score">{option.score}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="score-cell">
                                        <div className="current-score">
                                            {scores[item.category] !== null ? scores[item.category] : '-'}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="total-row">
                                <td><strong>TOTAL SCORE</strong></td>
                                <td className="max-score-note">(Maximal score is 15, Minimal score is 3)</td>
                                <td className="total-score-cell">
                                    <div className="total-score-display">
                                        <strong>{totalScore}</strong>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div className="note-section">
                    <p className="assessment-note">
                        <strong>References:</strong><br />
                        Teasdale G, Jennett B. "Assessment of coma and impaired consciousness. A practical scale." <em>The Lancet</em> 13;2(7872):81-4, 1974.
                    </p>
                </div>
            </div>
            <div className="general-form-actions">
                <button type="button" onClick={handleCancel} className="cancel-btn">Cancel</button>
                <button type="submit" onClick={handleFormSubmit} disabled={loading} className="submit-btn" style={{ cursor: loading ? 'wait' : 'pointer' }}>{loading ? 'Saving...' : 'Save'}</button>
            </div>
        </>
    );
};

export default Glasgow;